import React, { useState, useEffect } from 'react'
import { Button, TextField } from '@mui/material'
import { useLanguage } from '../LanguageContext'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { BACKEND_URI } from '../config'


function ProfilePage({
  user,
  onLogout,
  FundstoAdd,
  setFundstoAdd,
  setorderType,
}) {
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [FundsinAcct, setFundsinAcct] = useState(0)
  const [changingPassword, setChangingPassword] = useState(false)
  const [changingEmail, setChangingEmail] = useState(false)
  const [newEmail, setNewEmail] = useState('')
  const [emailVerification, setEmailVerfication] = useState()
  const [addingFunds, setAddingFunds] = useState(false)
  const [resendDisabled, setResendDisabled] = useState(false)
  const [resendTimer, setResendTimer] = useState(45) // Initial countdown
  const email = user.email
  const phonenumber = user.phonenumber

  const { language, toggleLanguage } = useLanguage()

  const translations = {
    en: {
      errorMessage_Fields: 'Please fill in all fields.',
      errorMessage_Confirm: 'New password and confirmation do not match.',
      successMessage: 'Password changed successfully!',
      title: 'Profile Settings',
      username: 'Username',
      label_currentpass: 'Current Password',
      label_newpass: 'New Password',
      label_confirmpass: 'Confirm New Password',
      changePassword: 'CHANGE PASSWORD',
      logout: 'LOGOUT',
    },
    es: {
      errorMessage_Fields: 'Por favor, completar todos los campos.',
      errorMessage_Confirm:
        'La nueva contraseña y la confirmación no coinciden.',
      successMessage: '¡Contraseña cambiada con éxito!',
      title: 'Configuración de Perfil',
      username: 'Nombre de usuario',
      label_currentpass: 'Contraseña Actual',
      label_newpass: 'Nueva Contraseña',
      label_confirmpass: 'Confirmar Nueva Contraseña',
      changePassword: 'CAMBIAR CONTRASEÑA',
      logout: 'CERRAR SESIÓN',
    },
  }

  const t = translations[language]

  useEffect(() => {
    const fetchFundsinAcct = async () => {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`${BACKEND_URI}/api/fundsinacct`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        const data = await response.json()
        setFundsinAcct(data)
      } catch (error) {
        console.error('Error fetching user funds:', error)
      }
    }

    fetchFundsinAcct() // ✅ Runs only once on component mount
  }, []) // ✅ Empty dependency array ensures it runs only once

  // 🔥 Separate useEffect for the Resend Timer
  useEffect(() => {
    let interval
    if (resendDisabled) {
      interval = setInterval(() => {
        setResendTimer(prev => {
          if (prev <= 1) {
            clearInterval(interval)
            setResendDisabled(false) // Enable button when timer ends
            return 45 // Reset timer for next use
          }
          return prev - 1
        })
      }, 1000)
    }
    return () => clearInterval(interval) // Cleanup on unmount
  }, [resendDisabled]) // ✅ Only runs when resendDisabled changes

  const handleChangePassword = async () => {
    setErrorMessage('')
    setSuccessMessage('')

    if (!currentPassword || !newPassword || !confirmPassword) {
      setErrorMessage('Please fill in all fields.')
      return
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage('New password and confirmation do not match.')
      return
    }

    const token = localStorage.getItem('token') // Get JWT from localStorage

    try {
      const response = await fetch(
        `${BACKEND_URI}/api/change-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include JWT in the Authorization header
          },
          body: JSON.stringify({ currentPassword, newPassword }),
        }
      )

      const data = await response.json()

      if (!response.ok) {
        setErrorMessage('Current Password not correct.')
      } else {
        // Success
        setSuccessMessage(data.message || 'Password changed successfully')
        setCurrentPassword('')
        setNewPassword('')
        setConfirmPassword('')
      }
    } catch (error) {
      // Catch any server or network errors
      console.error('Error changing password:', error)
      setErrorMessage(
        error.message || 'An error occurred while changing the password.'
      )
    }
  }

  const sendEmailVerification = async () => {
    const token = localStorage.getItem('token') // Get JWT from localStorage

    try {
      const response = await fetch(
        `${BACKEND_URI}/api/send-verification-email`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include JWT in the Authorization header
          },
        }
      )

      const data = await response.json()

      if (!response.ok) {
        setErrorMessage('error sending verification email')
      }
      setErrorMessage(data.message)
    } catch (error) {
      // Catch any server or network errors
      console.error('Error changing password:', error)
      setErrorMessage(
        error.message || 'An error occurred while changing the password.'
      )
    }
  }

  const handleResendVerification = () => {
    sendEmailVerification() // Call your API function to resend the email
    setResendDisabled(true) // Disable the button
    setResendTimer(45) // Reset countdown timer
  }

  const handleChangeEmail = async () => {
    setErrorMessage('')
    setSuccessMessage('')

    if (!newEmail || !emailVerification) {
      setErrorMessage('Please fill in all fields.')
      return
    }

    const token = localStorage.getItem('token') // Get JWT from localStorage

    try {
      const response = await fetch(`${BACKEND_URI}/api/change-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include JWT in the Authorization header
        },
        body: JSON.stringify({ newEmail: newEmail, code: emailVerification }),
      })

      const data = await response.json()

      if (!response.ok) {
        setErrorMessage('Verification Code not correct. Try Again.')
      }

      // Success
      setSuccessMessage(data.message || 'Email changed successfully')
      toast.success('Email Changed Successfully')

      setChangingEmail(false)
    } catch (error) {
      // Catch any server or network errors
      console.error('Error changing password:', error)
      setErrorMessage(
        error.message || 'An error occurred while changing the password.'
      )
    }
  }

  const handleUserAddFunds = () => {
    setorderType('Deposit')
    navigate('/checkout', {})
  }

  return (
    <div>
      <div style={styles.container}>
        {!changingPassword && !addingFunds && !changingEmail && (
          <>
            <h2 style={styles.heading}>{t.title}</h2>
            {/* <p style={styles.usernameText}>{t.username}: {user.username}</p> */}
            {/* <label style={styles.toggleLabel}>
        <input
          type="checkbox"
          checked={language === "es"}
          onChange={toggleLanguage}
          style={styles.checkbox}
        />
        {language === "en" ? "Switch to Spanish" : "Cambiar a Inglés"}
      </label> */}

            {/* User Name Section */}
            <h3 style={styles.subheading}>{'UserName'}</h3>
            <div style={styles.formGroup}>{user.username}</div>

            {/* Email Section */}
            <h3 style={styles.subheading}>{'Email Address'}</h3>
            <div style={styles.formGroupEmail}>
              {email}
              <Button
                onClick={e => {
                  setChangingEmail(true)
                }}
                variant='contained'
                color='primary'
                style={styles.changeEmailButton}
              >
                Change Email
              </Button>
            </div>

            {/* Phone Number Section */}
            <h3 style={styles.subheading}>{'Phone Number'}</h3>
            <div style={styles.formGroup}>{phonenumber}</div>

            {/* Funds Section */}
            {/* <h3 style={styles.subheading}>{'Funds in account'}</h3>
            <div style={styles.formGroupEmail}>
              ${FundsinAcct}
              <Button
                onClick={e => setAddingFunds(true)}
                variant='contained'
                color='primary'
                style={styles.changeEmailButton}
              >
                Add Funds
              </Button>
            </div> */}

            <div
              style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}
            >
              <Button
                onClick={e => setChangingPassword(true)}
                variant='contained'
                color='primary'
                style={styles.changePasswordButton}
              >
                Change Password
              </Button>
            </div>
          </>
        )}

        {/* {addingFunds && (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem',
              }}
            >
              <label>Funds to add (min: $20):</label>
              <input
                onChange={e => setFundstoAdd(parseFloat(e.target.value))}
                type='number'
                value={FundstoAdd}
                min={0}
              ></input>

              <Button
                onClick={handleUserAddFunds}
                variant='contained'
                color='primary'
                disabled={!FundstoAdd || FundstoAdd < 20}
              >
                Add funds to acct
              </Button>
            </div>
            <Button
              onClick={e => setAddingFunds(false)}
              variant='contained'
              color='error'
              style={styles.changePasswordButton}
            >
              Cancel
            </Button>
          </>
        )} */}

        {changingEmail && (
          <>
            {/* Change Email Section */}
            <h3 style={styles.subheading}>Change Email</h3>
            <div style={styles.formGroup}>
              <TextField
                label='New Email'
                value={newEmail}
                onChange={e => setNewEmail(e.target.value)}
                size='small'
                fullWidth
              />
            </div>
            <div style={styles.formGroup}>
              <TextField
                label='Verification Code'
                value={emailVerification}
                onChange={e => setEmailVerfication(e.target.value)}
                size='small'
                fullWidth
              />
            </div>
            {/* Resend Verification Button */}
            <Button
              onClick={handleResendVerification}
              variant='contained'
              // color="#fadac0"
              style={styles.resendButton}
              disabled={resendDisabled}
            >
              {resendDisabled
                ? `Resend in ${resendTimer}s`
                : 'Send Verification Code'}
            </Button>

            {errorMessage && <p style={styles.error}>{errorMessage}</p>}
            {successMessage && <p style={styles.success}>{successMessage}</p>}

            <Button
              onClick={handleChangeEmail}
              variant='contained'
              color='primary'
              style={styles.changePasswordButton}
            >
              Change Email
            </Button>
            <Button
              onClick={e => setChangingEmail(false)}
              variant='contained'
              color='error'
              style={styles.changePasswordButton}
            >
              Cancel
            </Button>
          </>
        )}

        {changingPassword && (
          <>
            {/* Change Password Section */}
            <h3 style={styles.subheading}>{t.changePassword}</h3>
            <div style={styles.formGroup}>
              <TextField
                label={t.label_currentpass}
                type='password'
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                size='small'
                fullWidth
              />
            </div>
            <div style={styles.formGroup}>
              <TextField
                label={t.label_newpass}
                type='password'
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                size='small'
                fullWidth
              />
            </div>
            <div style={styles.formGroup}>
              <TextField
                label={t.label_confirmpass}
                type='password'
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                size='small'
                fullWidth
              />
            </div>

            {errorMessage && <p style={styles.error}>{errorMessage}</p>}
            {successMessage && <p style={styles.success}>{successMessage}</p>}

            <Button
              onClick={handleChangePassword}
              variant='contained'
              color='primary'
              style={styles.changePasswordButton}
            >
              {t.changePassword}
            </Button>
            <Button
              onClick={e => setChangingPassword(false)}
              variant='contained'
              color='error'
              style={styles.changePasswordButton}
            >
              Cancel
            </Button>
          </>
        )}

        <Button
          onClick={onLogout}
          variant='outlined'
          style={styles.logoutButton}
        >
          {t.logout}
        </Button>
      </div>
    </div>
  )
}

export default ProfilePage

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '20px',
    marginTop: '70px',
    maxWidth: '500px',
    margin: '20px auto',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '10px',
  },
  subheading: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginTop: '20px',
    marginBottom: '10px',
  },
  usernameText: {
    fontSize: '1rem',
    textAlign: 'center',
    // marginBottom: "20px",
  },
  formGroup: {
    marginBottom: '10px',
  },
  formGroupEmail: {
    display: 'flex',
    flex: '1', // ✅ Takes up available space on the left
    flexDirection: 'column',
    marginBottom: '10px',
    gap: '10px',
  },
  changePasswordButton: {
    marginTop: '20px',
    padding: '8px 20px',
    alignSelf: 'center',
    backgroundColor: '#51a4ac',
  },
  changeEmailButton: {
    // marginTop: "20px",
    // padding: "8px 20px",
    width: '30%',
    backgroundColor: '#51a4ac',
    alignSelf: 'left',
  },
  createInviteCodeButton: {
    marginTop: '20px',
    padding: '8px 20px',
    alignSelf: 'right',
  },
  logoutButton: {
    marginTop: '10px',
    padding: '8px 20px',
    alignSelf: 'center',
    color: '#f00',
    borderColor: '#f00',
  },
  error: {
    color: 'red',
    fontSize: '0.9rem',
    textAlign: 'center',
  },
  success: {
    color: 'green',
    fontSize: '0.9rem',
    textAlign: 'center',
  },
  toggleLabel: {
    fontSize: '0.9rem',
    cursor: 'pointer',
  },
  checkbox: {
    marginRight: '5px',
  },
  buttonDisabled: {
    backgroundColor: 'grey',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontSize: '0.9rem',
  },
  saveButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'green',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '0.5rem',
  },
  cancelButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'red',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  resendButton: {
    backgroundColor: '#fadac0',
  },
}
